export default "__VITE_ASSET__9c987ee5__"